<template>
  <section class="image-loader-container">
    <img
      :src="error ? errorImageSrc : imageSrc"
      :alt="alt || 'image'"
      loading="lazy"
      draggable="false"
      @load="load = true"
      @error="error = true"
    />
    <article v-if="!load" class="image-loader-container-overlay">
      <slot><p>Loading ...</p></slot>
    </article>
  </section>
</template>
<script>
export default {
  data() {
    return {
      error: false,
      load: false,
    };
  },
  props: ["errorImageSrc", "imageSrc", "alt"],
};
</script>
<style scoped>
.image-loader-container {
  position: relative;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  min-width: 250px;
 min-height: 250px;
}

.image-loader-container img {
  min-width: 100%;
  width: 100%;
  height: 100%;
}

.image-loader-container-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
